var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricityPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4 4.79999C65.5 4.59999 65.2 4.39999 65.1 4.59999L31.3 38.4L23.1 46.7H38.1L19.6 80.2C19.5 80.4 19.8 80.6 19.9 80.4L53.5 46.7L61.7 38.4H46.9L65.4 4.79999Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.0902,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9001 28.8L30.8 44H39.2001H45.3L38.6 56.2L53.7001 41.1H45.8H39.2001L45.9001 28.8C46.0001 28.8 46.0001 28.8 45.9001 28.8Z",
    fill: "#FF931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9001 28.8L30.8 44H39.2001H45.3L38.6 56.2L53.7001 41.1H45.8H39.2001L45.9001 28.8ZM45.9001 28.8C46.0001 28.8 46.0001 28.8 45.9001 28.8Z",
    stroke: "#FF931E",
    strokeWidth: 0.9085,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityPrimary);
export default __webpack_public_path__ + "static/media/electricity-primary.fcc720b0669879c89f3b60c4bfe3f2c9.svg";
export { ForwardRef as ReactComponent };